angular.module('graph').controller('ph-preview', [
    '$scope', '$rootScope', 'ph-core', 'ph-broadcast',
    function(
        $scope, $root, $core, $broadcast
    ) {
        $scope.show      = false;
        $scope.images    = [];
        $scope.current   = null;
        $scope.source    = '';
        $scope.maxHeight = 600;
        $scope.maxWidth  = 900;

        $scope.$on('ph-preview-touch', function($event, $data) {
            if ($data.images.length > 0) {
                $scope.images  = $data.images;
                $scope.current = $data.current;

                $scope.render($data.current, true);

                $scope.open();
            }
        });

        $scope.open = function() {
            $scope.show = true;

            var w1 = document.body.offsetWidth, // body width with scroll
                w2;

            angular.element(
                'body'
            ).addClass(
                'lock'
            );

            w2 = document.body.offsetWidth; // body width without scroll

            // set difference of body width
            document.body.style.paddingRight = (w2 - w1) + "px";
            document.getElementsByClassName("headline")[0].style.paddingRight = (w2 - w1) + "px";
        };

        $scope.close = function() {
            $scope.show = false;

            document.body.style.paddingRight = "";
            document.getElementsByClassName("headline")[0].style.paddingRight = "";

            angular.element(
                'body'
            ).removeClass(
                'lock'
            )
        };

        $scope.render = function(current, reapply) {
            var $api = new Image();
            var $img = $scope.images[current ? current : $scope.current];

            $api.onload = function() {
                var w = window,
                d = document,
                e = d.documentElement,
                g = d.getElementsByTagName('body')[0],
                x = w.innerWidth || e.clientWidth || g.clientWidth,
                y = w.innerHeight|| e.clientHeight|| g.clientHeight;

                // console.log(x + 'x' + y);
                // console.log(this.width + 'x' + this.height);

                $scope.maxHeight = y - 100;
                $scope.maxWidth = x - 200;

                $scope.source = $img.source;

                if (reapply) $scope.$apply();
            };

            $api.src = $img.source;
        };

        $scope.next = function () {
            var current = $scope.current + 1;

            if (current > ($scope.images.length - 1))
                current = 0;

            $scope.current  = current;

            $scope.render(current, true);
        };

        $scope.prev = function() {
            var current = $scope.current - 1;

            if (current < 0)
                current = $scope.images.length - 1;

            $scope.current  = current;

            $scope.render(current, true);
        };

        angular.element('body').on('keydown keypress', function(e) {
            if(e.which === 27) {
                if ($scope.show === true) {
                    angular.element('.ph-preview .close').trigger('click');

                    e.preventDefault();
                }
            }

            if(e.which === 37) {
                if ($scope.show === true) {
                    $scope.prev();

                    e.preventDefault();
                }
            }

            if(e.which === 39) {
                if ($scope.show === true) {
                    $scope.next();

                    e.preventDefault();
                }
            }
        });

        angular.element('body').click(function(e) {
            if ($(e.target).hasClass('ph-preview-main') && $scope.show === true) {
                angular.element('.ph-preview .close').trigger('click');

                e.stopPropagation();
            }
        });
    }
]);
